module.exports = __webpack_public_path__ + "static/media/huntpost.f160aec8.png";